<template>
  <div class="default-layout">
    
      <Header :key="updateKey" />
      <SmoothScroll>
        <div data-scroll-section data-scroll>
         <PageTitle :pageTitle="this.$store.state.main.selected_menu.teaser" :titleColor="getColors[0]"  :bgColor="getColors[1]" />
          <router-view :key="updateKey"></router-view>
        <Footer />
        </div>
      </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from '@/components/SmoothScroll';


import PageTitle from '@/components/layout/PageTitle';

import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
export default {
components: {SmoothScroll, Header, PageTitle, Footer},
mounted(){
 console.log(this.$store.state.main.selected_menu)
},
computed: {
 
  getColors(){
    let cMenu;
    let c = [];
    let locale = this.$store.state.main.locale;
    cMenu = this.$store.state.main.indx.menus.filter(menu => menu.id == this.$store.state.main.selected_menu.id);
  
    c.push(_.get(cMenu[0], `titles.${locale}.primaryColor`))
    c.push(_.get(cMenu[0], `titles.${locale}.secondaryColor`))
    return c;
  },

  updateKey(){
    return this.$store.state.main.updateKey;
  },
  
},
watch:{
     $route: {
      immediate: true,
      deep: true,
      handler: function() {
        this.$store.state.main.updateKey += 1;
      }
    },
  }
}
</script>

<style>

</style>